import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { InformationalCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { Grid } from '@grnhse/seedling/lib/azalea/layouts/grid';
import ConfirmationModal from '@grnhse/seedling/lib/birch/components/modals/confirmation_modal';
import { BodyText } from '@grnhse/seedling/lib/azalea/typography';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { useModal } from '@grnhse/seedling/lib/birch/components/modals';
import { standardRequestWithFlash } from '../../shared/utils/request';

const t = withLocalePrefix('gdpr.single_purpose_consent_opt_in');

const SinglePurposeConsentOptIn = () => {
  const [optInModalIsOpen, openOptInModal, closeOptInModal] = useModal();
  const [submitting, setSubmitting] = React.useState(false);

  function OptInModal() {
    const cancelOptIn = () => {
      closeOptInModal();
    };

    const optInToSinglePurposeConsent = () => {
      setSubmitting(true);

      standardRequestWithFlash.patch('/gdpr/settings/spc_opt_in').then(() => {
        location.reload();
      });
    };

    return (
      <ConfirmationModal
        isOpen={optInModalIsOpen}
        ariaLabel={t('modal.header')}
      >
        <ConfirmationModal.Header>{t('modal.header')}</ConfirmationModal.Header>
        <ConfirmationModal.Body>
          <BodyText>{t('modal.body')}</BodyText>
        </ConfirmationModal.Body>
        <ConfirmationModal.Footer>
          <Grid item>
            <SecondaryButton onClick={cancelOptIn}>
              {t('modal.cancel')}
            </SecondaryButton>
          </Grid>
          <Grid item>
            <PrimaryButton
              onClick={optInToSinglePurposeConsent}
              disabled={submitting}
            >
              {t('modal.enable')}
            </PrimaryButton>
          </Grid>
        </ConfirmationModal.Footer>
      </ConfirmationModal>
    );
  }

  return (
    <Grid sx={{ marginBottom: 2 }}>
      <InformationalCallOut
        bodyText={t('call_out.body')}
        buttonProps={{
          children: t('call_out.button'),
          onClick: openOptInModal,
        }}
        headerText={t('call_out.header')}
        linkProps={{
          children: t('call_out.link'),
          href: 'https://support.greenhouse.io/hc/en-us/articles/14742758333595',
        }}
      />
      <OptInModal />
    </Grid>
  );
};

export default SinglePurposeConsentOptIn;
